export default "__VITE_ASSET__DTjSKvkR__"